import { render, staticRenderFns } from "./GameBackgroundMusic.vue?vue&type=template&id=3a895830&"
import script from "./GameBackgroundMusic.vue?vue&type=script&lang=js&"
export * from "./GameBackgroundMusic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports